<p class="tw-text-wrap tw-break-all">{{ send().file.fileName }}</p>
<button
  bitButton
  type="button"
  buttonType="primary"
  [bitAction]="download"
  [block]="true"
  startIcon="bwi-download"
>
  {{ "downloadAttachments" | i18n }} ({{ send().file.sizeName }})
</button>
